// Lista de actualizaciones visibles en la pantalla de login.
// SOLO muestra fecha + etiqueta genérica; nunca describe los cambios reales.
// Para agregar una nueva actualización, añade al inicio del array.
// Se muestran automáticamente las 4 más recientes.
export const UPDATES = [
  { date: "2026-08-25", label: "Nuevo módulo disponible" },
  { date: "2026-08-15", label: "Ajustes de la plataforma" },
  { date: "2026-08-12", label: "Mejoras generales" },
  { date: "2026-08-08", label: "Mejoras generales" },
  { date: "2026-08-01", label: "Optimización de rendimiento" },
  { date: "2026-02-08", label: "Mejoras generales" },
  { date: "2026-02-06", label: "Optimización de rendimiento" },
];

// Formatea "2026-02-08" -> "8 Feb 2026" en español.
export function formatUpdateDate(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const months = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
  ];
  return `${d} ${months[m - 1]} ${y}`;
}
